module.exports = __webpack_public_path__ + "static/media/arrow_down.2e39ac01.svg";